<template>

  <div :class="{switcher:true,flipped:!!flipped,disabled:disabled}" @click="clicked" :title="title">
    <h4 
      :class="{'switcher-label': true, clickable: !!switcherLabel2&&!disabled }" 
      @click="changeIt(null,false)" 
      v-html="switcherLabel" 
      v-if="switcherLabel&&switcherLabel!==''" 
    />
    <span :class="{ bar: true, on: content, switchColour: !sameColour }" @click="changeIt"></span>
    <h4 
      :class="{'switcher-label2': true, clickable: !disabled}" 
      v-if="switcherLabel2&&switcherLabel2!==''" 
      @click="changeIt(null,true)" 
      v-html="switcherLabel2" 
    />
  </div>

</template>

<script>
export default {
  name: 'Switcher',
  props: ['value','switcherLabel','switcherLabel2','sameColour','title','flipped'],
  props:{
    value: {
      type: Boolean,
      default: false
    },
    switcherLabel: {
      type: String,
      default: ''
    },
    switcherLabel2: {
      type: String,
      default: ''
    },
    sameColour: {
      type: Boolean,
      default: false
    },
    title: {
      type: String,
      default: ''
    },
    flipped: {
      type: Boolean,
      default: false
    },
    disabled: {
      type: Boolean,
      default: false
    }
  },
  methods: {
    clicked () {
      if ( this.disabled ) return; 
      this.$emit('clicked');
    },
    changeIt(e,val) {
      if ( this.disabled ) return;
      //if ( typeof val !== 'undefined' && typeof this.switcherLabel2 !== 'undefined' ) return;
      if ( typeof val === 'undefined' ) val = !this.content;
      this.$emit('input', val);
    }
  },
  watch: {
    value: {
      immediate: true, 
      handler (val, oldVal) {
        this.content = val;
      }
    }
  },
  data() {
    return {
      content: this.value
    }
  }
}
</script>
<style lang="less" scoped>
@import './../assets/css/less/_helper.less';
@import './../assets/css/less/_settings.less';

.switcher {

  display: inline-block; 
  vertical-align: top;
  margin: 4px 15px 0 0;
  -webkit-touch-callout: none; /* iOS Safari */
  -webkit-user-select: none; /* Safari */
  -khtml-user-select: none; /* Konqueror HTML */
  -moz-user-select: none; /* Old versions of Firefox */
  -ms-user-select: none; /* Internet Explorer/Edge */
  user-select: none;
  position: relative;

  .switcher-label, .switcher-label2 {

    font-size: 14px;
    display: inline-block;
    font-weight: normal;
    vertical-align: top;
    padding-top: 4px;

    &.clickable {
      cursor: pointer;
    }

  }

  .switcher-label2 {

    padding-left: 3px;

  }

  .bar {

    position:relative;
    display: inline-block;
    background: @borderColor;
    .rounded(50px);
    width: 40px;
    height: 24px;
    cursor: pointer;
    margin-left: 3px;
    .trans(all 0.1s linear);

    &:before {

      content: " ";
      position:absolute;
      .rounded(50px);
      background-color: #fff;
      width: 18px;
      height: 18px;
      left: 4px;
      top: 3px;
      z-index: 2;
      .trans(all 0.1s linear);

    }

    &.on {

      background-color: @darkContrast;

      &:before {

        left: 18px;

      }

      &.switchColour {

        &:before {

          background-color: @darkContrast;

        }

      }

    }

  }

  &.flipped {

     .switcher-label, .switcher-label2 {

      color: #fff;

     }

    .bar {

       background: #fff;

       &.on {

         background: #fff;

       }

        &:before {

          background-color: @darkContrast;

        }

    }

  }

  &.multi {

    .bar {

      width: 200px;

    }

  }

  &.disabled {

    opacity: 0.5;
    cursor: not-allowed;
    .opacity(0.5);

    .bar {

      cursor: not-allowed;

    }

  }

}
</style>